import { render, staticRenderFns } from "./photo-macula.vue?vue&type=template&id=392eaf0e&scoped=true&"
import script from "./photo-macula.vue?vue&type=script&lang=js&"
export * from "./photo-macula.vue?vue&type=script&lang=js&"
import style0 from "./photo-macula.vue?vue&type=style&index=0&id=392eaf0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392eaf0e",
  null
  
)

export default component.exports